import $ from 'jquery';
import 'jquery-ui/ui/core';
import 'slick-slider';
export async function topOfferSlider() {
    $('.js-top-offer').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 15000
    });

    const jsTopOffer = document.querySelector('.js-top-offer');
    if (jsTopOffer) {
        jsTopOffer.style.opacity = 1;
    }
}